import billplz_module from './billplz/store';
// import { vuex_module as toyyibpay_module } from './billplz/index'

export default {
  billplz_module,
  // toyyibpay_module
};
